<template>
  <v-col sm="12" md="6" lg="3" cols="12">
    <v-card min-height="150px">
      <slot></slot>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "DashBoardTopCardItem",
};
</script>

<style scoped></style>
